import type { BrandProfile } from './BrandProfile'

/**
 * Demo — нейтральний профіль для показу CRM клієнтам (ADR 048).
 *
 * Замінив разовий профіль конкретної компанії (2026-10-29): без її назви,
 * логотипа, фото й шрифту. Знак — власний, літера «D» на кольорі бренду.
 * Лишились темна тема за замовчуванням і помаранчева гама графіків.
 */
export const demo: BrandProfile = {
    id: 'demo',
    name: 'Demo',
    shortName: 'Demo',
    color: '#FF4D29',
    /* Темна тема — графітові тла замість чорного antd */
    darkTokens: {
        colorBgLayout: '#1A1B1D',
        colorBgContainer: '#1F2023',
        colorBgElevated: '#28292D',
    },
    defaultTheme: 'dark',
    /* Помаранчева головна серія, далі теплі відтінки й холодний контраст для графітового тла */
    chartPalette: ['#FF4D29', '#FF9F43', '#4FC3F7', '#FFD166', '#C77DFF', '#2EC4B6'],
    /* Стенд показують клієнтам — нагадуємо, що це не робоча система */
    headerNotice: 'DEMO версія. Не вносьте до системи реальні дані Вашої компанії та Ваших контрагентів',
    /* Знак на прозорому тлі — читається в обох темах без плашки */
    mark: { src: '/brands/demo/mark.png', plate: false },
    html: {
        title: 'Demo — CRM',
        favicon32: '/brands/demo/favicon-32.png',
        icon192: '/brands/demo/icon-192.png',
        appleTouchIcon: '/brands/demo/icon-192.png',
    },
    login: {
        /* Графітове тло з ледь помітним світінням кольору бренду під текстом */
        background:
            'radial-gradient(48% 52% at 24% 58%, rgba(255, 77, 41, 0.12) 0%, rgba(255, 77, 41, 0) 70%), ' +
            'linear-gradient(180deg, #1F2023 0%, #1A1B1D 100%)',
        headline: ['Логістична CRM', { text: 'Demo', accent: true }],
        lead: ['Заявки, рейси й перевізники в одному місці.', 'Увійдіть, щоб продовжити.'],
        caption: 'Справи · Клієнти · Перевізники · Заявки · Звіти',
    },
}
